'use client';

import type { PropsWithChildren } from 'react';
import join from 'url-join';

import { getCWEA } from '../../utils';
import { CopilotKit, useChatThread } from '../runtime';
import { chatHeaders } from '../utils';

interface ChatbotProviderProps {
    enabled?: boolean;
}

export function ChatbotProvider({ children, enabled = true }: PropsWithChildren<ChatbotProviderProps>) {
    if (!enabled) return <>{children}</>;

    return <EnabledChatbotProvider>{children}</EnabledChatbotProvider>;
}

function EnabledChatbotProvider({ children }: PropsWithChildren) {
    const { threadId } = useChatThread();

    return (
        <CopilotKit
            headers={chatHeaders}
            runtimeUrl={join(getCWEA(), 'chat/runtime')}
            useSingleEndpoint={false}
            threadId={threadId}
        >
            {children}
        </CopilotKit>
    );
}
